// src/components/fraud/FraudDestinations.js
// Top Destination Numbers table widget.
// Columns: Destination | Attempts Today | Blocked Count

import React from 'react';
import { Table } from 'react-bootstrap';

// ─── Skeleton ────────────────────────────────────────────────────────────────
const SkeletonRows = () =>
  Array.from({ length: 5 }).map((_, i) => (
    <tr key={i} style={{ borderBottom: '1px solid var(--divider)' }}>
      {[140, 60, 60].map((w, j) => (
        <td key={j} className="transparent-header py-3">
          <div className="fraud-skeleton" style={{ width: w, height: 12, borderRadius: 4 }} />
        </td>
      ))}
    </tr>
  ));

// ─── Main ────────────────────────────────────────────────────────────────────
const FraudDestinations = ({ destinations, loading }) => (
  <div id="fraud-destinations-table" className="theme-card rounded-3 p-4 h-100">
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h6 className="mb-0 text-h2" style={{ fontSize: 15 }}>
        Top Destination Numbers
      </h6>
      <span
        style={{
          fontSize: 11,
          color: 'var(--text-secondary)',
          background: 'rgba(255,255,255,0.06)',
          borderRadius: 20,
          padding: '2px 10px',
        }}
      >
        By attempts
      </span>
    </div>

    <div className="table-responsive">
      <Table className="align-middle body-text-two mb-0">
        <thead>
          <tr>
            {['Destination', 'Attempts Today', 'Blocked Count'].map((col) => (
              <th key={col} className="transparent-header" style={{ fontSize: 12, fontWeight: 600 }}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <SkeletonRows />
          ) : destinations.length === 0 ? (
            <tr>
              <td colSpan={3} className="transparent-header text-center py-4">
                <div style={{ color: 'var(--text-secondary)', fontSize: 13 }}>
                  <span style={{ fontSize: 24 }}>📵</span>
                  <p className="mt-2 mb-0">No destination data found</p>
                </div>
              </td>
            </tr>
          ) : (
            destinations.map((dest, idx) => {
              const blockRate = dest.attempts > 0 ? (dest.blocked / dest.attempts) * 100 : 0;
              return (
                <tr key={dest.destination || idx} style={{ borderBottom: '1px solid var(--divider)' }}>
                  <td
                    className="transparent-header py-3"
                    style={{ fontSize: 13, fontFamily: 'monospace', fontWeight: 500 }}
                  >
                    {dest.destination}
                  </td>
                  <td className="transparent-header py-3" style={{ fontSize: 13, fontWeight: 600 }}>
                    {dest.attempts}
                  </td>
                  <td className="transparent-header py-3">
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: dest.blocked > 0 ? '#EF4444' : '#22C55E',
                      }}
                    >
                      {dest.blocked}
                    </span>
                    {dest.blocked > 0 && (
                      <small
                        style={{
                          marginLeft: 6,
                          fontSize: 10,
                          color: 'var(--text-secondary)',
                        }}
                      >
                        ({Math.round(blockRate)}%)
                      </small>
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </div>
  </div>
);

export default FraudDestinations;
